//import jQuery from 'jquery'
import { gsap } from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";
//import { SplitText } from 'gsap/SplitText';
//import { GSDevTools } from 'gsap/GSDevTools';

class CustomAnimation {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    //this.animateAlpha('.footer_headline');
    //this.animateFooter('.footer');
    this.animateGlobalFunctions();
  }

  animateGlobalFunctions () {
    //header image
    if (document.querySelector('.header_background')) {
      jQuery('.header_background').css("background-image", "url("+ jQuery('.header_background').data('bg-image') +")");
      this.animateHeaderImage('.header_background');
    }

      // footer
    if (document.querySelector('.footer_background')) {
      jQuery('.footer_background').css("background-image", "url("+ jQuery('.footer_background').data('bg-image') +")");
    }
    this.animateFooterText('.footer_headline');
    this.animateFooter('.footer');

    // basic_text_holder
    if (document.querySelector('.header_background')) {
      this.animateTextGroup('.basic_text_holder');
    }

    // button holder
    if (document.querySelector('.button_holder')) {
      this.animateButtonGroup('.button_holder');
    }

    // basic_image_holder
    if (document.querySelector('.basic_image_holder')) {
      this.animateImageGroup('.basic_image_holder');
    }


    // text_box
    if (document.querySelector('.text_box')) {
      this.animateScaleAndMoveGroup('.text_box');
    }

    // business_boost_box
    if (document.querySelector('.business_boost_box')) {
      this.animateScaleAndMoveGroup('.business_boost_box');
    }

    // overview_box
    if (document.querySelector('.splide__slide')) {
      this.animateScaleAndMoveGroup('.splide__slide');
    }

    // clients_video_holder
    if (document.querySelector('.clients_video_holder')) {
      this.animateScaleAndMoveGroup('.clients_video_holder');
    }

    // contact_form
    if (document.querySelector('.contact_form')) {
      this.animateScaleAndMoveGroup('.contact_form');
    }

    // pricing_boxes_toggle_button
    if (document.querySelector('.pricing_boxes_toggle_button')) {
      this.animateButtonGroup('.pricing_boxes_toggle_button');
    }

    // pricing_box
    if (document.querySelector('.pricing_box')) {
      this.animateScaleAndMoveGroup('.pricing_box');
    }

    // pricing_table_holder
    if (document.querySelector('.pricing_table_holder')) {
      this.animateFromBottomGroup('.pricing_table_holder');
    }

    // pricing_table_teaser
    if (document.querySelector('.pricing_table_teaser')) {
      this.animateScaleAndMoveGroup('.pricing_table_teaser');
    }

    // search_form
    if (document.querySelector('.search_form')) {
      this.animateFromBottomGroup('.search_form');
    }

    // features_button_holder
    if (document.querySelector('.features_button_holder')) {
      this.animateFromBottomGroup('.features_button_holder');
    }

    // filter_buttons
    if (document.querySelector('.filter_buttons')) {
      this.animateFromBottomGroup('.filter_buttons');
    }

    // blog_grid
    if (document.querySelector('.blog_grid')) {
      this.animateScaleAndMoveGroup('.blog_grid');
    }

    // icon_box
    if (document.querySelector('.icon_box')) {
      this.animateScaleGroup('.icon_box');
    }

    // icon_box_holder
    if (document.querySelector('.icon_box_holder')) {
      this.animateScaleGroup('.icon_box_holder');
    }

    // faq_item
    if (document.querySelector('.faq_item')) {
      //this.animateFaqGroup('.faq_item');
    }


    ScrollTrigger.refresh();
  }
  animateHeaderImage(element){
    gsap.to(element, {
      scrollTrigger: {
        trigger: '.header',
        start: 'top 0%',
        end: 'bottom 0%',
        markers: false,
        scrub: 0
      },
      y: 200
    });
  }

  animateTextGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 75%',
          markers: false,
          scrub: 0
        },
        y: 50
      });
    });
  }

  animateButtonGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        alpha: 0,
        y: 50
      });
    });
  }

  animateImageGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        scale: .95,
        y: 50
      });
    });
  }

   animateScaleAndMoveGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 50,
        scale: .9
      });
    });
  }

  animateScaleGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 101%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 10,
        scale: .9
      });
    });
  }

  animateFromBottomGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 75%',
          markers: false,
          scrub: 0
        },
        y: 50
      });
    });
  }

  animateFooterText(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 100%',
        end: 'top 40%',
        markers: false,
        scrub: 0
      },
      scale: 1.2
    });
  }
  animateFooter(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',      // Startet wenn Footer-Top den Viewport-Bottom erreicht
        end: 'top top',        // Endet wenn Footer-Top die Viewport-Mitte erreicht
        markers: false,
        scrub: 0
      },
      y: -250
    });
  }

  animateFaqGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 80%',
          markers: false,
          scrub: 0
        },
        y: 50,
        scale: .9
      });
    });
  }




  animateScaleDown(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 100%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      scale: .95,
      y: 50
    });
  }

  animateBgImage(element, trigger){
    gsap.from(element, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top 110%',
        end: 'top 20%',
        markers: false,
        scrub: 0
      },
      y: -200
    });
  }

  animateIntro() {
    gsap.from('.intro_container', {
      scrollTrigger: {
        trigger: '.intro',
        start: 'center 110%',
        end: 'bottom 70%',
        markers: false,
        scrub: 0
      },
      y: -50,
      scale: .9
    });
  }


  animateElement(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 50
    });
  }

  animateContactDetail(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 150
    });
  }

  animateText(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 50,
      scale: .94
    });
  }

  animateImage(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 150
    });
  }

  animateBackgroundImage(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 90%',
        end: 'bottom 10%',
        markers: false,
        scrub: 0
      },
      y: 50
    });
  }

  animateFromLeft(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: -60
    });
  }

  animateFromRight(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: 60
    });
  }

  animateButtonHolder(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: 20
    });
  }


  animateDemotext(element) {
    gsap.to(element, {
      scrollTrigger: {
        trigger: element,
        start: 'center 50%',
        end: 'bottom 30%',
        markers: false,
        scrub: 0
      },
      y: 200
    });
  }

  animateDemoForm(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'center 50%',
        end: 'bottom 30%',
        markers: false,
        scrub: 0
      },
      y: 0
    });
  }
}

export default CustomAnimation;
